module.exports = __webpack_public_path__ + "kudos_63.svg?5ff7552289a7f1b8d6d4741b4dfa0197";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_63.svg
// module id = 165
// module chunks = 0